/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversationMessages } from '../../models/api-response-conversation-messages';
import { PagedRequestMessage } from '../../models/paged-request-message';

export interface ListMessagesOfContacts$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  contactRef: string;
  phoneCompanyRef: string;
      body: PagedRequestMessage
}

export function listMessagesOfContacts(http: HttpClient, rootUrl: string, params: ListMessagesOfContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversationMessages>> {
  const rb = new RequestBuilder(rootUrl, listMessagesOfContacts.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('contactRef', params.contactRef, {});
    rb.query('phoneCompanyRef', params.phoneCompanyRef, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversationMessages>;
    })
  );
}

listMessagesOfContacts.PATH = '/v1/api/ui/message/contact/{contactRef}/list';
